import React, {PureComponent} from "react";
import Connect from "react-redux/es/connect/connect";
import {withTranslation} from "react-i18next";
import {PropTypes} from "prop-types";
import Form from "react-bootstrap/Form";
import {debug, find} from "../../utility/functions";
import {
	dispatchOnMultimediaAddFileModeChanged,
	dispatchOnMultimediaAuthorChanged,
	dispatchOnMultimediaClearForm,
	dispatchOnMultimediaCreateFile,
	dispatchOnMultimediaCreateFileFailure,
	dispatchOnMultimediaCreateFileSuccess,
	dispatchOnMultimediaEditFile,
	dispatchOnMultimediaEditFileFailure,
	dispatchOnMultimediaEditFileSuccess,
	dispatchOnMultimediaNameChanged,
	dispatchOnMultimediaRemoveFile,
	dispatchOnMultimediaRemoveFileFailure,
	dispatchOnMultimediaRemoveFileSuccess,
	dispatchOnMultimediaSetAuthorGeneral,
	dispatchOnMultimediaSetAuthors,
	dispatchOnMultimediaSetFilesPicked,
	dispatchOnMultimediaSetNameGeneral,
	dispatchOnMultimediaSetNames,
	dispatchOnMultimediaSetSelectedFilePicked, dispatchOnMultimediaUploadedFilesWithSomeIgnored
} from "./functions";
import Image from "react-bootstrap/Image";
import Trash from "../../assets/trash.png";
import {
	alertError,
	alertSuccess,
	alertUnauthorized,
	createMultimedia,
	editMultimedia,
	removeMultimedia
} from "../../actions";
import Config from '../../config'

class FileComponent extends PureComponent {

	componentDidMount() {
		const {childRef} = this.props;
		childRef(this);
	}

	onCreateMultimedia = () => {
		const {names, authors, filesPicked, name_all, author_all} = this.props;
		const oldFiles = this.props.files;
		if (this.validateMultimediaForm(true)) {
			this.props.dispatchOnMultimediaCreateFile();
			const files = [];
			const filesIgnored = [];
			names.forEach((value, index) => {
				if((author_all && author_all.length > 0) || (authors[index] || authors[index].length > 0)) {
					files.push({
						name: name_all && name_all.length > 0? name_all : value,
						src: filesPicked[index],
						author: author_all && author_all.length > 0? author_all : authors[index],
					})
				} else {
					filesIgnored.push(index);
				}
			});

			debug("Files -> ", files);
			debug("Files Ignored -> ", filesIgnored);

			createMultimedia({files})
				.then((response) => {
					debug("Response -> ", response);
					if(filesIgnored.length > 0) {
						alertUnauthorized(filesIgnored.length + " ficheiros não foram carregados por não terem o campo 'Autor' preenchido");
						this.props.dispatchOnMultimediaUploadedFilesWithSomeIgnored(
							oldFiles,
							find(response, 'filesSuccess'),
							filesPicked.filter((value, index) => {
								return filesIgnored.some((v, i) => index === v)
							}),
							names.filter((value, index) => {
								return filesIgnored.some((v, i) => index === v)
							}),
							authors.filter((value, index) => {
								return filesIgnored.some((v, i) => index === v)
							})
						)
					} else {
						this.props.dispatchOnMultimediaCreateFileSuccess(find(response, 'filesSuccess'))
					}

				})
				.catch((error) => {
					this.props.dispatchOnMultimediaCreateFileFailure()
				});
		}
	};

	onEditMultimedia = () => {
		const {name, author, file} = this.props;
		if (this.validateMultimediaForm()) {
			this.props.dispatchOnMultimediaEditFile();
			editMultimedia(find(file, 'id'), {name, author})
				.then((response) => {
					debug("Response -> ", response);
					this.props.dispatchOnMultimediaEditFileSuccess(response.data);
				})
				.catch((error) => {
					this.props.dispatchOnMultimediaEditFileFailure(error);
				});
		}
	};

	onRemoveMultimedia = () => {
		const {name, author, file} = this.props;
		this.props.dispatchOnMultimediaRemoveFile();
		removeMultimedia(find(file, 'id'))
			.then((response) => {
				debug("Response -> ", response);
				alertSuccess(response.message);
				this.props.dispatchOnMultimediaRemoveFileSuccess(file);
			})
			.catch((error) => {
				this.props.dispatchOnMultimediaRemoveFileFailure(error);
			});
	};

	clearForm = () => {
		this.props.dispatchOnMultimediaClearForm();
	};

	validateMultimediaForm = (validateFile = false) => {
		const {filesPicked} = this.props;

		if (validateFile && (!filesPicked || filesPicked.length === 0)) {
			alertUnauthorized("Selecione um ficheiro do computador");
			return false;
		}

		return true;
	};

	onSelectedFilePickedNameChanged = (e) => {
		let {names, selectedFilePicked, edit, name} = this.props;

		if(edit) {
			this.props.dispatchOnMultimediaNameChanged(name)
		}

		if (!names) names = [];

		if (names.length === 0) {
			names.push(e.target.value);
		} else {
			names[selectedFilePicked] = e.target.value;
		}

		this.props.dispatchOnMultimediaSetNames([...names]);
	};

	onSelectedFilePickedAuthorChanged = (e) => {
		let {authors, selectedFilePicked, edit, author} = this.props;

		if(edit) {
			this.props.dispatchOnMultimediaAuthorChanged(author)
		}

		if (!authors) authors = [];

		if (authors.length === 0) {
			authors.push(e.target.value);
		} else {
			authors[selectedFilePicked] = e.target.value;
		}

		this.props.dispatchOnMultimediaSetAuthors([...authors]);
	};

	isFilePickedSelected = (index) => {
		const {selectedFilePicked} = this.props;
		return selectedFilePicked === index;
	};

	onFileSelected = (index) => {
		this.props.dispatchOnMultimediaSetSelectedFilePicked(index);
	};

	onFilePicked = (event) => {
		let {names, authors, filesPicked} = this.props;

		if (!names) names = [];
		if (!authors) authors = [];
		if (!filesPicked) filesPicked = [];

		if (this.props.onFilePicked) {
			this.props.onFilePicked(event);
			return;
		}

		const files = event.target.files;
		if (files && files.length > 0) {
			let ignoredFiles = 0;
			for (let i = 0; i < files.length; i++) {
				const image = files[i];
				const reader = new FileReader();
				const name = image.name.split(".")['0'];

				debug("file exists? -> ", this.isFileInFilesPicked(name));
				if (!this.isFileInFilesPicked(name)) {
					names.push(name);
					authors.push("");

					reader.addEventListener("load", () => {
						filesPicked.push(reader.result);
						if (i === files.length - 1) {
							this.props.dispatchOnMultimediaSetFilesPicked([...filesPicked], [...names], [...authors]);
							if (ignoredFiles > 0) {
								alertUnauthorized("Foram ignorados " + ignoredFiles + " ficheiros duplicados")
							}
						}
					});
					reader.readAsDataURL(image);
				} else {
					ignoredFiles++;
					if (i === files.length - 1) {
						alertUnauthorized("Foram ignorados " + ignoredFiles + " ficheiros duplicados")
					}
				}
			}
		}
	};

	onGeneralNameChanged = (e) => {
		this.props.dispatchOnMultimediaSetNameGeneral(e.target.value);
	};

	onGeneralAuthorChanged = (e) => {
		this.props.dispatchOnMultimediaSetAuthorGeneral(e.target.value);
	};

	isFileInFilesPicked = (name) => {
		const {filesPicked, names} = this.props;

		if (!filesPicked || filesPicked.length === 0) return false;

		return names.some(value => name === value)
	};

	onRemoveFileFromFilesPicked = (index) => {
		const {filesPicked, names, authors} = this.props;
		this.props.dispatchOnMultimediaSetFilesPicked(
			[...filesPicked.filter((value, i) => i !== index)],
			[...names.filter((value, i) => i !== index)],
			[...authors.filter((value, i) => i !== index)]
		);
	};

	render() {
		const {filesPicked} = this.props;

		return (
			<div className='row col-xs-12 col-sm-12 col-md-12 col-lg-12'>
				<div className='col-xs-4 col-sm-4 col-md-4 col-lg-4'>
					{this.renderFilePicker()}
					{this.renderSelectedFilePickedName()}
					{this.renderSelectedFilePickedAuthor()}
				</div>
				<div className='col-xs-8 col-sm-8 col-md-8 col-lg-8'>
					<div className='row'>
						{this.renderGeneralName()}
						{this.renderGeneralAuthor()}
					</div>
					<div className='row col-xs-12 col-sm-12 col-md-12 col-lg-12 multimedia-file-modal-files-selected-container'>
						{this.renderMultipleFiles()}
					</div>
				</div>
			</div>
		)
	}

	renderGeneralName = () => {
		const {filesPicked, name_all, remove} = this.props;

		if (!filesPicked || filesPicked.length <= 1) return null;

		return (
			<div className='form-group col-xs-6 col-sm-6 col-md-6 col-lg-6'>
				<Form.Label column={true} aria-required={true}>{"Nome Geral"}</Form.Label>
				<Form.Control
					type={'text'}
					value={name_all}
					readOnly={remove}
					onChange={this.onGeneralNameChanged}
				/>
			</div>
		)
	};

	renderGeneralAuthor = () => {
		const {filesPicked, author_all, remove} = this.props;

		if (!filesPicked || filesPicked.length <= 1) return null;

		return (
			<div className='form-group col-xs-6 col-sm-6 col-md-6 col-lg-6'>
				<Form.Label column={true}>{"Autor Geral"}</Form.Label>
				<Form.Control
					type={'text'}
					value={author_all}
					readOnly={remove}
					onChange={this.onGeneralAuthorChanged}
				/>
			</div>
		)
	};

	renderSelectedFilePickedName = () => {
		const {names, selectedFilePicked, edit, remove, name} = this.props;

		let value = "";

		if (names && names.length > 0) {
			value = names[selectedFilePicked]
		}

		if(remove || edit) {
			value = name
		}

		return (
			<div className='row form-group col-xs-12 col-sm-12 col-md-12 col-lg-12'>
				<Form.Label column={true} aria-required={true}>{"Nome do ficheiro"}</Form.Label>
				<Form.Control
					type={'text'}
					required
					value={value}
					readOnly={remove}
					onChange={this.onSelectedFilePickedNameChanged}
				/>
			</div>
		)
	};

	renderSelectedFilePickedAuthor = () => {
		const {authors, author_all, selectedFilePicked, edit, remove, author} = this.props;

		let value = "";

		if (authors && authors.length > 0) {
			value = authors[selectedFilePicked]
		}

		if(remove || edit) {
			value = author
		}

		return (
			<div className='row form-group col-xs-12 col-sm-12 col-md-12 col-lg-12'>
				<Form.Label column={true} aria-required={true}>{"Autor do ficheiro"}</Form.Label>
				<Form.Control
					type={'text'}
					required={!author_all || author_all.length === 0}
					value={value}
					readOnly={remove}
					onChange={this.onSelectedFilePickedAuthorChanged}
				/>
			</div>
		)
	};

	renderMultipleFiles = () => {
		let {filesPicked, names, edit, remove, file, name, author} = this.props;

		debug("name", name);
		debug("author", author);
		debug("file", file);

		if(edit || remove) {
			return(
				<Image
					className='modal-body-multimedia-file modal-body-multimedia-file-preview'
					src={Config.urlImages + find(file, 'src')}
					thumbnail={true}
				/>
			)
		};

		if(!filesPicked) return null;

		return filesPicked.map((file, index) => {
			const isSelected = this.isFilePickedSelected(index);
			const className = isSelected ? " files-container-selected" : "";
			return (

				<div
					key={file.substr(55, 65) + "-" + index}
					className={"files-container" + className}
					onClick={() => {
						this.onFileSelected(index)
					}}
				>
					<div>
						<div className="files-container-image">
							<Image
								key={'multimedia-image-' + file.substr(55, 65) + index}
								className='img-multimedia-files'
								src={file}
							/>
						</div>
						<div className='files-container-bottom'>
							<span className="files-container-span">{names[index]}</span>
							<div className='files-container-actions'>
								<img
									className='files-container-action-remove'
									src={Trash}
									alt={""}
									onClick={() => {
										this.onRemoveFileFromFilesPicked(index)
									}}
								/>
							</div>
						</div>
					</div>
				</div>
			)
		});
	};

	renderFilePicker = () => {
		const {t, showFilePicker} = this.props;

		if(this.filePicker) {
			this.filePicker.value = null;
		}

		if (showFilePicker) {
			return (
				<div className='row col-xs-12 col-sm-12 col-md-12 col-lg-12'>
					<Form.Group>
						<Form.Control
							ref={ref => this.filePicker = ref}
							type="file"
							accept="image/*"
							id="file"
							onChange={this.onFilePicked}
							multiple
						/>
						<Form.Label column={true} htmlFor="file">{t("Select Files")}</Form.Label>
					</Form.Group>
				</div>
			)
		}
	};
}

FileComponent.propTypes = {
	edit: PropTypes.bool,
	remove: PropTypes.bool,
	showFileName: PropTypes.bool,
	showFileAuthor: PropTypes.bool,
	showFilePicker: PropTypes.bool,
	onFilePicked: PropTypes.func,
	onFileNameChanged: PropTypes.func,
	onFileAuthorChanged: PropTypes.func,
};

FileComponent.defaultProps = {
	edit: false,
	remove: false,
	showFileName: true,
	showFileAuthor: true,
	showFilePicker: false,
	onFilePicked: null,
	onFileNameChanged: null,
	onFileAuthorChanged: null,
};

const mapStateToProps = store => ({
	name_all: store.multimediaReducer.name_all,
	names: store.multimediaReducer.names,
	name: store.multimediaReducer.name,
	author_all: store.multimediaReducer.author_all,
	authors: store.multimediaReducer.authors,
	author: store.multimediaReducer.author,
	filesPicked: store.multimediaReducer.filesPicked,
	selectedFilePicked: store.multimediaReducer.selectedFilePicked,
	file: store.multimediaReducer.file,
	files: store.multimediaReducer.files,

});

const mapFunctionsToProps = {
	dispatchOnMultimediaSetNames,
	dispatchOnMultimediaSetNameGeneral,
	dispatchOnMultimediaSetAuthors,
	dispatchOnMultimediaSetAuthorGeneral,
	dispatchOnMultimediaSetFilesPicked,
	dispatchOnMultimediaSetSelectedFilePicked,
	dispatchOnMultimediaClearForm,
	dispatchOnMultimediaNameChanged,
	dispatchOnMultimediaAuthorChanged,
	dispatchOnMultimediaCreateFile,
	dispatchOnMultimediaCreateFileSuccess,
	dispatchOnMultimediaCreateFileFailure,
	dispatchOnMultimediaEditFile,
	dispatchOnMultimediaEditFileSuccess,
	dispatchOnMultimediaEditFileFailure,
	dispatchOnMultimediaRemoveFile,
	dispatchOnMultimediaRemoveFileSuccess,
	dispatchOnMultimediaRemoveFileFailure,
	dispatchOnMultimediaAddFileModeChanged,
	dispatchOnMultimediaUploadedFilesWithSomeIgnored
};

export default Connect(mapStateToProps, mapFunctionsToProps)(withTranslation("translations")(FileComponent));
